/**
 * OfflineIndicator Component
 * 
 * Mostra un banner quando l'app è offline e il numero di azioni in attesa.
 */

import { WifiOff, RefreshCw, CloudOff, Check } from 'lucide-react';

const OfflineIndicator = ({ isOnline, pendingCount, isSyncing, onSync }) => {
  // Non mostrare nulla se online e nessuna azione pending
  if (isOnline && pendingCount === 0) {
    return null;
  }

  // Mostra banner sincronizzazione in corso
  if (isOnline && isSyncing) {
    return (
      <div className="fixed top-0 left-0 right-0 z-[9998] bg-blue-500 text-white px-4 py-2 flex items-center justify-center gap-2 shadow-lg animate-pulse">
        <RefreshCw className="w-4 h-4 animate-spin" />
        <span className="text-sm font-medium">
          Sincronizzazione in corso...
        </span>
      </div>
    );
  }

  // Mostra banner azioni pending (online ma con azioni da sincronizzare)
  if (isOnline && pendingCount > 0) {
    return (
      <div className="fixed top-0 left-0 right-0 z-[9998] bg-amber-500 text-white px-4 py-2 flex items-center justify-between shadow-lg">
        <div className="flex items-center gap-2">
          <CloudOff className="w-4 h-4" />
          <span className="text-sm font-medium">
            {pendingCount} {pendingCount === 1 ? 'azione' : 'azioni'} in attesa
          </span>
        </div>
        <button
          onClick={onSync}
          className="flex items-center gap-1 bg-white/20 hover:bg-white/30 px-3 py-1 rounded-full text-sm transition-colors"
        >
          <RefreshCw className="w-3 h-3" />
          Sincronizza
        </button>
      </div>
    );
  }

  // Mostra banner offline
  if (!isOnline) {
    return (
      <div className="fixed top-0 left-0 right-0 z-[9998] bg-gray-800 text-white px-4 py-2 flex items-center justify-center gap-2 shadow-lg">
        <WifiOff className="w-4 h-4" />
        <span className="text-sm font-medium">
          Modalità Offline
          {pendingCount > 0 && (
            <span className="ml-2 bg-white/20 px-2 py-0.5 rounded-full text-xs">
              {pendingCount} in coda
            </span>
          )}
        </span>
      </div>
    );
  }

  return null;
};

export default OfflineIndicator;
